import React from "react";
import "./Experience.css";

// MARK: - Skills
// TODO: Rename any 'experience' mention here and its CSS to 'skills'
const Experience = () => {
  return (
    <section id="experience">
      <h2>Skills</h2>
      <div className="container experience__container">
        <div className="experience__frontend">
          <h3>iOS expertise</h3>
          <div className="experience__content">
            <article className="experience__details">
              <div>
                  <p>Swift</p>
                  <p>SwiftUI & UIKit</p>
                  <p>MVVM Architecture</p>
                  <p>Async-Await</p>
                  <p>AVFoundation</p>
                  <p>WidgetKit</p>
                  <p>Combine</p>
                  <p>StoreKit / StoreKit 2</p>
                  <p>Core Data</p>
              </div>
            </article>
          </div>
        </div>

        <div className="experience__backend">
          <h3>Web development</h3>
          <div className="experience__content">
            <article className="experience__details">
              <div>
                  <p>JavaScript/HTML/CSS</p>
                  <p>PHP</p>
                  <p>React JS</p>
                  <p>Redux</p>
                  <p>useState, useEffect, useContext, useCallback, useMemo</p>
                  <p>GraphQL, REST APIs</p>
              </div>
            </article>
          </div>
        </div>

        <div className="experience__backend">
          <h3>Tooling & Engineering</h3>
          <div className="experience__content">
            <article className="experience__details">
              <div>
                  <p>Git / Github</p>
                  <p>CI/CD (CircleCI, Fastlane, GitHub Actions)</p>
                  <p>Automated Testing (Swift Testing, XCTest, Quick/Nimble, Jest)</p>
                  <p>Code Review & Collaboration</p>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
